import React, { useContext, useEffect } from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import { store as mainStore } from '../../../../../store';
import { localText } from '../../../../../langs/fa/data-grid';
import { store } from './Freights';
import NoFreights from './NoFreights';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';

const FreightsList = () => {
  const history = useHistory();
  const {
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { users, isLoaded, page, search },
    dispatch,
    actions: { fetchingFreights },
  } = useContext(store);
  const columns = [
    { field: 'firstName', headerName: 'نام', flex: 1 },
    { field: 'lastName', headerName: 'نام‌خانوادگی', flex: 1 },
    { field: 'nationalCode', headerName: 'کدملی', width: 130 },
    { field: 'company', headerName: 'نام‌شرکت', width: 150 },
    { field: 'companyNationalCode', headerName: 'شناسه‌شرکت', width: 150 },
    { field: 'phone', headerName: 'تلفن', width: 150 },
    { field: 'mobilePhone', headerName: 'موبایل', width: 150 },
    { field: 'status', headerName: 'وضعیت', width: 120 },
  ];
  const handlePageChange = async ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectOrder = (selection) => {
    // const [userId] = selection.rowIds;
    const userId = selection.row.id;
    // const { role } = users.docs.find((u) => u._id === userId);
    history.push(`/protected/admin/users/freight/${userId}`);
  };
  useEffect(() => {
    if (!page) return;
    (async () => {
      const res = await fetchingFreights(page, itemsCountPerPage, search);
      dispatch({ type: 'FREIGHTS', payload: res });
    })();
  }, [page]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <DataGrid
        rows={
          users && users.docs
            ? users.docs.map((u) => ({
                id: u._id,
                firstName: u.firstName,
                lastName: u.lastName,
                nationalCode: u.nationalCode,
                company: u.company,
                companyNationalCode: u.companyNationalCode,
                phone: u.phone,
                mobilePhone: u.mobilePhone,
                status: __(u.status),
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={users && users.totalDocs ? users.totalDocs : 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={!isLoaded}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoFreights,
        }}
        onCellClick={handleSelectOrder}
      />
    </div>
  );
};

export default React.memo(FreightsList);
